<div class="calendar-popup" tabindex="0" role="button" (keydown.enter)="$event.stopPropagation()" (keyup.space)="$event.stopPropagation()" (click)="$event.stopPropagation()" [style.top.px]="top">
    <!-- Navigation Buttons -->
    <div class="calendar-header" *ngIf="!showMonths && !showCalendar">
      <div class="nav-button">
        <button type="button" class="custom-calendar-prev-btn" (click)="previousRange()"
          [disabled]="commonObj.headPrevDisabled">
          <mat-icon fontSet="material-symbols-outlined">chevron_left</mat-icon>
        </button>
      </div>
  
      <div class="f-col custom-calendar-value" tabindex="0" role="button" (keydown.enter)="openLastMonthOfYear()" (keyup.space)="openLastMonthOfYear()" (click)="openLastMonthOfYear()">
        <button type="button" class="button-as-div year-range year-cell" (click)="onYearRangeClick()">
          <b> {{ currentRangeStart }} – {{ currentRangeStart+20 }} </b>
        </button>
        
        <button type="button" *ngIf="isHijri" class="button-as-div year-range year-cell" (click)="onYearRangeClick()">
          {{ getHijriYear(currentRangeStart + '-01-01') }} – {{ getHijriYear((currentRangeStart + 20) + '-01-01') }}
        </button>
      </div>
  
  
      <div class="nav-button">
        <button type="button" class="custom-calendar-next-btn" [disabled]="isNextRange" (click)="nextRange()"
        [disabled]="commonObj.headNextDisabled">
        <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
      </button>
      </div>
     
    </div>
  
    <!-- Year Grid -->
    <div class="year-grid" *ngIf="!showMonths && !showCalendar">
      <div class="year-cell" *ngFor="let year of years" [class.disabled]="year.disabled">
        <div *ngIf="isHijri" class="hijri-month">{{ year.hijri }}</div>
        <button type="button" class="button-as-div" (click)="!year.disabled && selectYear(year.gregorian)" [ngClass]="{ 'disabled': year.disabled }">
          {{ year.gregorian }}
        </button>
      </div>
    </div>
  
  
    <!-- Month Grid -->
    <div class="year-grid" *ngIf="showMonths && !showCalendar">
      <div class="calendar-header">
        <div class="nav-button">
          <button type="button" class="button-as-div custom-calendar-prev-btn" (click)="previousMonthRange()"
          [disabled]="maxDate.year+1==selectedYear || commonObj.headPrevDisabled">
          <mat-icon fontSet="material-symbols-outlined">chevron_left</mat-icon>
        </button>
        </div>
  
        <button type="button" class="button-as-div f-col custom-calendar-value" (click)="openLastMonthOfYear()">
          <b> {{ selectedYear }}</b>
          <div *ngIf="isHijri">
            {{ selectedHijriYear }}
          </div>
        </button>
  
        <div class="nav-button">
          <button type="button" class="custom-calendar-next-btn" (click)="nextMonthRange()"
          [disabled]="maxYearRange<=selectedYear || commonObj.headNextDisabled">
          <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
        </button>
        </div>
        
      </div>
  
      <!-- Iterate over months and add a "disabled" class if the month is disabled -->
      <!-- <button type="button" *ngFor="let month of months" class="button-as-div year-cell" [class.selected]="month.gregorian === selectedMonth" -->
      <button type="button" *ngFor="let month of months"  class="button-as-div year-cell" [class.selected]="month.gregorian === selectedMonth"
        [class.disabled]="month.disabled" [ngClass]="{ 'disabled': month.disabled }"
        (click)="!month.disabled && selectMonth(month.gregorian)"> <!-- Prevent clicking if disabled -->
        <div *ngIf="isHijri" class="hijri-month">{{ month.hijri}}.</div>
        <div>{{ month.gregorian }}</div>
    </button>
    </div>
  
    <!-- Calendar Grid -->
    <div class="calendar-grid" *ngIf="showCalendar">
      <div class="calendar-header">
        <div class="nav-button">
          <button type="button" class="custom-calendar-prev-btn" (click)="previousDayRange()"
            [disabled]="commonObj.headPrevDisabled">
            <mat-icon fontSet="material-symbols-outlined">chevron_left</mat-icon>
          </button>
        </div>
  
        <button type="button" class="button-as-div f-col custom-calendar-value" (click)="backToYearRange()">
          <b>{{ selectedMonth | uppercase }} {{ selectedYear }}</b>
          <div *ngIf="isHijri">
            {{ selectedHijriMonth}} {{ selectedHijriYear }}
          </div>
        </button>
  
        <div class="nav-button">
          <button type="button" class="custom-calendar-next-btn" (click)="nextDayRange()"
            [disabled]="commonObj.headNextDisabled">
            <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
          </button>
        </div>
      </div>
  
      <!-- Day Headers -->
      <div class="day-grid">
        <!-- <div class="day-cell header">Sun</div>
        <div class="day-cell header">Mon</div>
        <div class="day-cell header">Tue</div>
        <div class="day-cell header">Wed</div>
        <div class="day-cell header">Thu</div>
        <div class="day-cell header">Fri</div>
        <div class="day-cell header">Sat</div> -->
  
        <!-- Actual Days -->
        <button type="button" *ngFor="let day of autoGeneratedDays" class="button-as-div day-cell"
          [ngClass]="{'selected': getCalendarStatus(day), 'disabled': day.disabled}"
          (click)="day.day !== null && selectDay(day.day)">
          <div *ngIf="isHijri && day.hijri" class="hijri-date">{{ day.hijri }}</div>
          <div *ngIf="day.day !== null">{{ day.day }}</div>
        </button>
      </div>
    </div>
  
    <div class="f-row buttons calender-selction-action">
      <div class="show__toggle">
        <!-- <div class="roundtrip-selection" (click)="onReset()">
            <div id="resetButton" role="button" class="resetdate" aria-label="Reset Dates" tabindex="0">Reset Dates</div>
          </div> -->
        <div class="hijri-dates">
          <div class="hijri">
            <label class="switch" [ngClass]="{'switchtoggle':isHijri}">
              <input class="toggleBox" id="hijiriCheckbox" tabindex="-1" aria-label="Hijri Calendar"
                (change)="toggleCalendar()" type="checkbox" [checked]="isHijri" [disabled]="false">
              <div></div>
            </label>
            <span id="toggleHijriText" aria-hidden="true">Hijri Calendar</span>
          </div>
        </div>
  
      </div>
      <div class="buttons_input">
        <button mat-button type="button" (click)="confirmSelection()"
          class="button--primary-small mat-button btn">Confirm</button>
      </div>
    </div>
  </div>